<template>
  <div id="app">
    <PageLoading v-if="isLoadingPage" />
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PageLoading from '@/components/PageLoading.vue';
import { getUserProfile, getToken } from '@/utils/common';
import regionServices from "@/services/region";
import s3Services from '@/services/simple-storage';

export default {
  name: "App",
  components: {
    PageLoading,
  },
  methods: {
    ...mapActions(['updateS3Info']),
    ...mapActions(['updateIsLoadingS3']),
    ...mapActions(['updateWarningServiceModal']),
    ...mapActions(['updateIsLoadingPage']),
    ...mapActions(["updateRegions"]),
    getUserProfile,
    async getSimpleStorageMe() {
      try {
        const res = await Promise.all([s3Services.getS3UserInfo(), s3Services.getEndpoint()]);
        if (!res?.[0].data?.data) {
          const res = await s3Services.createS3UserInfo();
          this.updateS3Info({
            ...res?.[0].data?.data,
            endpoints: res?.[1]?.data?.data.endpoints.global,
          });
          return;
        }
        await this.updateS3Info({
          ...res?.[0].data?.data,
          endpoints: res?.[1]?.data?.data.endpoints.global,
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.updateIsLoadingS3(false);
      }
    },
    async getListRegion() {
      try {
        const response = await regionServices.getListRegion();
        this.updateRegions(response.data.data);
      } catch (_) { }
    },
  },
  computed: {
    ...mapGetters(['s3Info']),
    ...mapGetters(['isLoadingPage']),
    ...mapGetters(['isLoadingS3']),
    ...mapGetters(['warningServiceModal']),
    ...mapGetters(["isLoadingPage"]),
  },
  beforeMount() {
    const isPublicRoute = /^\/billing\/bills\//.test(window.location.pathname);
    if (getToken('access_token') || !isPublicRoute) {
      this.getUserProfile();
    }
    this.getListRegion();
  },
  watch: {
    warningServiceModal(newData, oldData) {
      if (!!newData) {
        this.$alert(this.$t('app.lbServiceNotActivated'), this.$t('app.notice'), {
          confirmButtonText: this.$t('button.ok'),
          type: "warning",
          callback: action => {
            this.updateWarningServiceModal(false)
          }
        });
        if (this.$route.path !== '/dashboard') {
          this.$router.push('/')
        }
      }
    },

    $route(to, from) {
      if (to.path.includes('simple-storage') && !this.s3Info?.user_id) {
        this.updateIsLoadingS3(true);
        this.getSimpleStorageMe();
      }
    },
  },
};
</script>

<style scoped></style>
